import React from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parseCardBrandImageUrl } from '../../utils/manager/card-manager';
import { cardBackgroundColor } from './payment-card-list-item';

function PaymentCardDeleteModalBody({ card }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        src={parseCardBrandImageUrl(card)}
        alt={card.brand}
        className={classes.brand}
      />
      **** {card?.last4}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    backgroundColor: cardBackgroundColor,

    // border: '1px solid red',
  },
  brand: {
    marginTop: layoutDefaults.verticalMargin,
    marginBottom: layoutDefaults.verticalMargin,
    height: 50,
  },
});

export { PaymentCardDeleteModalBody };
